import { Paper, Typography, styled } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "rgba(255, 255, 255, 0.05)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  borderRadius: "10px",
}));

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) {
    return '$0.00';
  }
  return Number(amount).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const TokenCard = ({ token }) => {
  const quantity = token.amount;
  const valuePerToken = token.priceToken;
  const name = token.token.name;
  const symbol = token.token.symbol;

  const totalValue = (quantity || 0) * (valuePerToken || 0);

  return (
    <StyledPaper>
      <Typography variant="h6" color="text.primary">
        {name} ({symbol})
      </Typography>
      <Typography variant="h6" color="text.secondary">
        Cantidad: {(quantity || 0).toLocaleString()} tokens
      </Typography>
      <Typography variant="h6" color="text.secondary">
        Valor por token: {formatCurrency(valuePerToken)}
      </Typography>
      <Typography variant="h6" color="text.secondary">
        Valor Total: {formatCurrency(totalValue)}
      </Typography>
    </StyledPaper>
  );
};

export default TokenCard;